import { render, staticRenderFns } from "./RadioAnswer.vue?vue&type=template&id=af796d62&"
import script from "./RadioAnswer.vue?vue&type=script&lang=js&"
export * from "./RadioAnswer.vue?vue&type=script&lang=js&"
import style0 from "./RadioAnswer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports